import React from "react";
import { useNavigate } from "react-router-dom";
import "../../products/productDetail.css";

const ProductRequestTableData = ({ data, index, currentPage }) => {
  const navigate = useNavigate();

  return (
    <tr className="table-rows1" key={index}>
      <td className="table-each-row-data">
        {(currentPage - 1) * 10 + (index + 1)}
      </td>
      <td className="table-each-row-data">{data?.code ? data?.code : "--"}</td>
      <td className="table-each-row-data">
        {`DR. ${data?.name.toUpperCase()}`}
      </td>
      <td className="table-each-row-data">
        {data.doctorProductOffers.length ?? 0}
      </td>
      <td className="table-each-row-data">
        <div className="all-button">
          <button
            className="button-view"
            type="button"
            onClick={() =>
              navigate(`/customers/product-offer-request/view/${data?.id}`)
            }
          >
            {"view"}
          </button>
        </div>
      </td>
    </tr>
  );
};

export default ProductRequestTableData;

export const approvalStatus = [
  { status: "pending", value: "Pending", color: "Medium_Purple" },
  { status: "approved", value: "Approved", color: "text_green" },
  { status: "rejected", value: "Rejected", color: "text-danger" },
];
